import React, {Component} from 'react';
import swal from 'sweetalert';
import Modal from '../../../components/Modal';
import { callerActionsHistorySocial } from '../../../libs/services';
import ModalPrintLabel from '../../generics/ModalPrintLabel';


class GenerateRegisterSocial extends Component{
    constructor(props){
        super(props);

        this.onClose = this.onClose.bind(this);
        this.onSave = this.onSave.bind(this);
        this.setActive = this.setActive.bind(this);
        this.openModal = this.openModal.bind(this);
        this.openModalLabel = this.openModalLabel.bind(this);

        this.state = {            
            btns:[
                {active:false, text:'Sangre Total', priority:3},
                {active:false, text:'Aféresis', priority:2},
                {active:false, text:'Altruista', priority:1},
            ]
        }
    }

    componentDidMount(){
        this.props.onRef(this);
    }

    openModal(){        
        this.modal.handleShow();
    }

    onClose(){
        this.setState({
            btns:[
                {active:false, text:'Sangre Total', priority:3},
                {active:false, text:'Aféresis', priority:2},
                {active:false, text:'Altruista', priority:1},
            ]
        });
    }

    openModalLabel(type, id, extraction, print, ficha){
		this.modal_print_label.handleShow(type,id, extraction, print, this.props.preview_print, 'offers', ficha);
	}

    async onSave(){
        var btns = this.state.btns;

        var canSave = false;
        var priority = '';
        btns.forEach((b, j)=>{
            if(b.active){
                canSave = true;
                priority = b.priority;
            }
        });

        if(canSave){
            var obj = {
                num_records: 1,
				priority: priority,
				health_facilities_id: sessionStorage.getItem("health_facilities_id")
            };

            var response = await callerActionsHistorySocial(obj, this.props.waiting);
            if(response){
                this.modal.handleClose();
                this.openModalLabel('label_caller', response.id, null, true, response.record_number)
                window.location.reload();
            }
          
        }else{
            swal('Error', 'Debe seleccionar una opción', 'error');
        }
    }

    setActive(i){
        var btns = this.state.btns;

        btns.forEach((b, j)=>{
            if(i === j){
                b.active = true;
            }else{
                b.active = false;
            }
        });

        this.setState({btns: btns});
    }

    render(){
        return(
            <Modal
                title='Tipo de Donación'
                clear={this.onClose}
                actionBtn={true}
                label="Guardar"
                action={this.onSave}
                onRef={ref => this.modal = ref}
            >
                <div className='row'>
                    <div className='col-xs-12'>
                        {this.state.btns.map((btn, i)=>
                            <div className='col-xs-12 col-sm-4' key={i}>
                                <button 
                                    className={'btn '+(btn.active ? 'btn-info' : 'btn-default')}
                                    style={{width:'100%', fontSize:16}}
                                    onClick={()=>this.setActive(i)}
                                >
                                    {btn.text}
                                </button>
                            </div>
                        )}                        
                    </div>
                </div>

                <ModalPrintLabel {...this.props} onRef={ref => (this.modal_print_label = ref)} directPrint={this.props.directPrint}/>
            </Modal>
        )
    }
}

export default GenerateRegisterSocial;